import React from 'react'
import chileFlag from 'images/footer/chile.png'
import mexicoFlag from 'images/footer/mexico.png'
import googlePlayLogo from 'images/googleplay-es.png'
import appleStoreLogo from 'images/applestore-logo.png'
import Hr from '../Hr/Index'
const LogoSection = ({desktopLogo, b2b}) => {
    return (
        <div className="logo-section">
            <a href=""><img src={desktopLogo} alt="" /></a>

            <p>Tu espacio de bienestar y autocuidado personal.</p>
            <div className="lnd-stores-logos-container">
            <a href="https://play.google.com/store/apps/details?id=com.psycaid.terapi&hl=es_CL&gl=US&pli=1">
                <img src={googlePlayLogo} alt="" className="lnd-store-logo" />
            </a>
            <a href="https://apps.apple.com/us/app/terapi-psic%C3%B3logos-online/id1547374655">
                <img src={appleStoreLogo} alt="" className="lnd-store-logo" />
            </a>
            </div>
            <Hr/>
            <div className="lnd-social-network-logos-container">
                <a href="https://www.facebook.com/terapiapp/">
                    <i className="fab fa-facebook lnd-logo"></i>
                </a>
                <a href="https://www.instagram.com/terapi_app/?hl=es">
                    <i className="fab fa-instagram lnd-logo"></i>
                </a>
                <a href="https://cl.linkedin.com/company/terapiapp">
                    <i className="fab fa-linkedin lnd-logo"></i>
                </a>
            </div>

            {b2b ? 
            (<div className="countries-directions">
                <div className='country-direction'>
                    <img src={chileFlag} alt="" />
                    <p>Nueva Los Leones 0233, Providencia, Santiago, 7500000, Chile</p>
                </div>
                <div className='country-direction'>
                    <img src={mexicoFlag} alt="" />
                    <p>Prolongación Paseo De La Reforma 1015, Ciudad de México, 05348, México</p>
                </div>
            </div>)
            :
            <p>contacto@terapi-app.com</p>
            }
        </div>
    )
}

export default LogoSection
